export default __webpack_public_path__ + "static/media/lynda.f70574e3.svg";